var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUtaIcon = function SvgUtaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F80",
    d: "M0 14h21a5 5 0 0 0 5-5V0H5a5 5 0 0 0-5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#050505",
    d: "m10.922 4.092-.846 4.212c-.315 1.575-1.377 2.25-2.565 2.25-1.089 0-1.953-.693-1.953-1.827 0-.171.036-.414.063-.549l.819-4.086h1.188L6.791 8.25c-.018.108-.045.261-.045.396 0 .441.243.855.846.855.684 0 1.152-.468 1.323-1.314l.819-4.095zm5.236 0-.207 1.053h-1.575L13.305 10.5h-1.188l1.07-5.355h-1.61l.207-1.053zm3.926 6.408h-1.206l-.135-1.17h-2.169l-.603 1.17h-1.269l3.492-6.408h.945zm-1.43-2.142-.307-2.466-1.287 2.466z"
  })));
};
export default SvgUtaIcon;